import { Injectable } from '@angular/core';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import {
  CartLinkClickApplicationEvent, ElementVisibilityInViewportApplicationEvent,
  PdpInteractionApplicationEvent, PdpOfferPriceSyncIssueApplicationEvent,
  PdpRegisterAsBusinessApplicationEvent,
  QuantityPickerInteractionApplicationEvent,
  PdpFoodCategoryLinkApplicationEvent, AddToCartMoreThanInStockApplicationEvent
} from '~shared/modules/application-event/models';
import { ApplicationEventType } from '~shared/modules/application-event/constants';
import {GaTrackingEventLabel, GATrackingEventType} from '~shared/modules/ga-tracking/constants';

@Injectable(
  {
    providedIn: 'root'
  }
)

export class ProductTrackingService {
  constructor(private applicationEventService: ApplicationEventService) {
  }

  public trackOutOfStockNotifyClick(productName: string) {
    this.applicationEventService.publish(
      new PdpInteractionApplicationEvent(
        ApplicationEventType.OutOfStockNotifyClick,
        productName
      )
    );
  }

  public trackExploreSimilarProductsClick(productName: string) {
    this.applicationEventService.publish(
      new PdpInteractionApplicationEvent(
        ApplicationEventType.ExploreSimilarProductsClick,
        productName
      )
    );
  }

  public trackCartLinkClick() {
    this.applicationEventService.publish(
      new CartLinkClickApplicationEvent(GaTrackingEventLabel.ProductPage)
    );
  }

  public trackQuantityChange(label: string) {
    this.applicationEventService.publish(
      new QuantityPickerInteractionApplicationEvent(label)
    );
  }

  public trackSeller(sellerName: string) {
    this.applicationEventService.publish(
      new PdpInteractionApplicationEvent(
        ApplicationEventType.PdpSellerInteraction,
        sellerName
      )
    );
  }

  public trackRegisterAsBusiness() {
    this.applicationEventService.publish(
      new PdpRegisterAsBusinessApplicationEvent(
        GaTrackingEventLabel.PDPRegisterAsBusinessClicked
      )
    );
  }

  public trackProductHighlightsVisibility() {
    this.applicationEventService.publish(
      new ElementVisibilityInViewportApplicationEvent(
        GATrackingEventType.PdpScrolling, GaTrackingEventLabel.ProductHighlights)
    );
  }

  public trackProductDescriptionVisibility() {
    this.applicationEventService.publish(
      new ElementVisibilityInViewportApplicationEvent(
        GATrackingEventType.PdpScrolling, GaTrackingEventLabel.ProductDescription)
    );
  }

  public trackOfferPriceSyncIssue(productId: string) {
    this.applicationEventService.publish(
      new PdpOfferPriceSyncIssueApplicationEvent(productId)
    );
  }

  public trackPDPFoodCategoryLink(label: string) {
    this.applicationEventService.publish(
      new PdpFoodCategoryLinkApplicationEvent(label,
        GATrackingEventType.PDPFoodCategoryLink)
    );
  }

  public trackAddToCartMoreThanInStock(productName: string) {
    this.applicationEventService.publish(
      new AddToCartMoreThanInStockApplicationEvent(productName)
    );
  }
}
